import { render, staticRenderFns } from "./hotArea.vue?vue&type=template&id=ad50a560&scoped=true&"
import script from "./hotArea.vue?vue&type=script&lang=js&"
export * from "./hotArea.vue?vue&type=script&lang=js&"
import style0 from "./hotArea.vue?vue&type=style&index=0&id=ad50a560&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad50a560",
  null
  
)

export default component.exports